import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const PrimaryButtonTabs = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-primary-tab-button ifms-button-tabs">
      {children}
    </IfmsButton>
  );
});

PrimaryButtonTabs.defaultProps = {
};

PrimaryButtonTabs.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
};

export default React.memo(PrimaryButtonTabs);